import React from 'react';
import { HiArrowLeft } from 'react-icons/hi';
import { useNoteContext } from '@/components/notes/context/NoteContext';

const BackToLatestButton: React.FC = () => {
  const { isReadOnly, onBackToLatest } = useNoteContext();

  if (!isReadOnly) return null;

  return (
    <button
      type="button"
      onClick={onBackToLatest}
      className="flex items-center gap-1 px-2 py-1 rounded text-xs font-medium
        text-amber-700 dark:text-amber-400
        bg-amber-50 dark:bg-amber-900/30
        border border-amber-300 dark:border-amber-700
        hover:bg-amber-100 dark:hover:bg-amber-900/50
        transition-colors"
      title="Return to the latest version"
      aria-label="Back to latest version"
    >
      <HiArrowLeft size={13} />
      Back to latest
    </button>
  );
};

export default BackToLatestButton;

